import { api } from "~/api/Api";
import { defineComponent, ref } from "vue";
import { Log } from "~/extensions/utils";
import { useRouter } from "vue-router";
import { GetTokenResult } from "~/api/data/Admin/Auth/GetTokenResult";
import { auth } from "~/core/Auth";
const log = Log.create("passwordChange");
export default defineComponent({
    name: "PasswordChange",
    setup() {
        let tokenResult = new GetTokenResult();
        const router = useRouter();
        const token = ref("");
        const functionsUrl = ref("");
        const fullUrl = ref("");
        const isPasswordReset = auth.isPasswordReset;
        const toTop = () => {
            router.push({ name: "top" });
        };
        const initView = async () => {
            if (!isPasswordReset) {
                // 先にタブを開く
                const newTab = window.open("about:blank", "_blank");
                if (!newTab) {
                    console.error("新しいタブを開けませんでした", newTab);
                    return;
                }
                tokenResult = await api.auth.token();
                if (tokenResult) {
                    token.value = tokenResult.oneTimeToken;
                    functionsUrl.value = tokenResult.url;
                    fullUrl.value = `${functionsUrl.value}?token=${encodeURIComponent(token.value)}`;
                    // 開いておいたタブにURLを入れる
                    newTab.location.href = fullUrl.value;
                }
                else {
                    console.error("データが存在しません", tokenResult);
                }
                router.push({ name: "top" });
            }
        };
        initView();
        const openPasswordChange = async () => {
            // 先にタブを開く
            const newTab = window.open("about:blank", "_blank");
            if (!newTab) {
                console.error("新しいタブを開けませんでした", newTab);
                return;
            }
            tokenResult = await api.auth.token();
            if (tokenResult) {
                token.value = tokenResult.oneTimeToken;
                functionsUrl.value = tokenResult.url;
                fullUrl.value = `${functionsUrl.value}?token=${encodeURIComponent(token.value)}`;
                // 開いておいたタブにURLを入れる
                newTab.location.href = fullUrl.value;
            }
            else {
                console.error("データが存在しません", tokenResult);
            }
            await auth.logout();
            router.push({ name: "login" });
        };
        return {
            token,
            fullUrl,
            toTop,
            isPasswordReset,
            openPasswordChange
        };
    }
});
